import axios from "axios";

// Use relative path for production (nginx proxies /api to backend)
// Use explicit URL for local development
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sofia_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatAED(n) {
  if (n == null) return "—";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)} million Dirhams`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K Dirhams`;
  return `${n.toLocaleString()} Dirhams`;
}

export function bedroomsLabel(b) {
  if (b == null) return "Mixed units"; // mixed full-floor listings (e.g. Bay Views) store bedrooms = NULL
  if (b === 0) return "Studio";
  if (b === 1) return "1 Bedroom";
  return `${b} Bedrooms`;
}
